module.exports = __webpack_public_path__ + "static/media/dragunov.721e9eb7.jpg";